import {
  Transactions,
  TransactionStatus,
  FUserDataType,
} from '../types/commonTypes';

const transactionList: Transactions[] = [
  {
    postedDate: '03 June 2024',
    data: [
      {
        vendor: 'Amazon',
        status: TransactionStatus.PENDING,
        amount: '$ 45.00',
      },
      {
        vendor: 'E-Bay',
        status: TransactionStatus.DECLINED,
        amount: '$ 22.00',
      },
    ],
  },
  {
    postedDate: '04 June 2024',
    data: [
      {
        vendor: 'Tim Hortons',
        status: TransactionStatus.APPROVED,
        amount: '$ 11.95',
      },
    ],
  },
];

export const firstTimeUser: FUserDataType = {
  isFirstTime: true,
  rewardBalance: '$ --.--',
  rewardRedumptionBonus: '$ --.--',
  currentBalance: '$0.00',
  availableCredit: '$2,000.00',
  digitalCardSummary: {
    id: 8744,
    userName: 'epptest07',
    productName: 'Rogers Red World Elite® Mastercard®',
    productExternalCode: '20220429173723',
    cardLast4: '8744',
    creditLimit: {
      value: '10000.00',
      currency: 'CAD',
    },
  },
  transactionList: [],
};

export const registeredUser: FUserDataType = {
  isFirstTime: false,
  rewardBalance: '$ 100.00',
  rewardRedumptionBonus: '$ 125.00',
  currentBalance: '$0.00',
  availableCredit: '$1,476.77',
  paymentDue: 'July 29',
  statementBalance: '$523.23',
  minimumPayment: '$265.23',
  transactionList: transactionList,
  digitalCardSummary: {
    id: 8744,
    userName: 'epptest07',
    productName: 'Rogers Red World Elite® Mastercard®',
    productExternalCode: '20220429173723',
    cardLast4: '8744',
    creditLimit: {
      value: '10000.00',
      currency: 'CAD',
    },
  },
};
